"use client";

import { ReactNode, useEffect, useMemo, useState } from "react";

type AdminThemeId = "midnight" | "royal-blue" | "crimson";

const STORAGE_KEY = "mq_admin_theme";

const THEMES: Array<{ id: AdminThemeId; label: string }> = [
  { id: "midnight", label: "Midnight" },
  { id: "royal-blue", label: "Royal Blue" },
  { id: "crimson", label: "Crimson" },
];

function isAdminThemeId(v: string | null): v is AdminThemeId {
  return v === "midnight" || v === "royal-blue" || v === "crimson";
}

export function AdminThemeRoot({
  children,
  showSelector = true,
}: {
  children: ReactNode;
  showSelector?: boolean;
}) {
  const [theme, setTheme] = useState<AdminThemeId>("midnight");
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (isAdminThemeId(saved)) {
        setTheme(saved);
      }
    } catch {
      // ignore
    } finally {
      setHydrated(true);
    }
  }, []);

  useEffect(() => {
    if (!hydrated) return;
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      // ignore
    }
  }, [theme, hydrated]);

  const options = useMemo(() => THEMES, []);

  return (
    <div className="admin-theme-root" data-admin-theme={theme}>
      {showSelector ? (
        <div className="admin-theme-selector-float">
          <div className="muted" style={{ fontSize: ".82rem", marginBottom: ".35rem" }}>
            Tema
          </div>
          <select
            value={theme}
            onChange={(e) => setTheme(e.target.value as AdminThemeId)}
            className="admin-theme-select"
            aria-label="Admin tema seçimi"
          >
            {options.map((t) => (
              <option key={t.id} value={t.id}>
                {t.label}
              </option>
            ))}
          </select>
        </div>
      ) : null}

      {children}
    </div>
  );
}

